import { createReducer, on } from '@ngrx/store';

import { available } from './security.action';

const initialState = false;

export const securityReducer = createReducer(
  initialState,
  on(available, (state, { available }) => available)
);
